// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"4de0747f","356":"8544d189","556":"5809e2d9","647":"8f6f69ec","758":"6d4cf5f8","772":"89c3cbeb","774":"ba61e90a","805":"be4506f0","823":"24e34ebf"}[chunkId] + ".chunk.css";
};